import React, { useEffect, useState } from "react";
import { formatDateTime } from "../utils/formatDate";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Row, Col } from "react-bootstrap";
import "../App.css";

function AttemptPage() {
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState(null);
  const [previousAttempt, setPreviousAttempt] = useState(null);
  const location = useLocation();
  const { assessmentId, attempt } = location.state || {};
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [previousAnswers, setPreviousAnswers] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser && parsedUser.user_id) {
          setUserId(parsedUser.user_id);
        }
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!assessmentId) {
      setError("No assessment ID provided.");
      return;
    }

    const fetchSettings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/getAssessmentSetting`,
          {
            params: {
              assessment_id: assessmentId,
            },
          }
        );

        if (response.data.success) {
          setSettings(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch assessment settings");
        }
      } catch (err) {
        setError(err.response?.data?.message || "An unexpected error occurred");
      }
    };

    fetchSettings();
  }, [assessmentId]);

  useEffect(() => {
    const fetchPreviousAttemptStats = async () => {
      if (!userId || !assessmentId) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/getPreviousAttemptStats`,
          {
            params: {
              userId,
              assessmentId,
            },
          }
        );

        if (response.data.success) {
          setPreviousAttempt(response.data.data);
        } else {
          console.error("Failed to fetch previous attempt stats:", response.data.message);
        }
      } catch (err) {
        console.error("Error fetching previous attempt stats:", err);
      }
    };

    fetchPreviousAttemptStats();
  }, [userId, assessmentId]);

  useEffect(() => {
    const fetchPreviousAnswers = async () => {
      if (!userId || !assessmentId) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/getDraftAnswers`,
          {
            params: {
              userId,
              assessmentId,
            },
          }
        );

        if (response.data.success) {
          setPreviousAnswers(response.data.data);
        } else {
          console.error("Failed to fetch previous attempt stats:", response.data.message);
        }
      } catch (err) {
        console.error("Error fetching previous attempt stats:", err);
      }
    };

    fetchPreviousAnswers();
  }, [userId, assessmentId]);

  const handleExamClick = () => {
    navigate("/exammcq", {
      state: {
        assessment_name: settings.assessment_name,
        time: settings.time,
        questions: settings.questions,
        assessment_id: assessmentId,
        attempts: attempt,
      },
    });
  };

  const handlePreviousExamClick = () => {
    navigate("/previousexammcq", {
      state: {
        assessment_name: settings.assessment_name,
        time: settings.time,
        questions: settings.questions,
        assessment_id: assessmentId,
        attempts: attempt,
      },
    });
  };

  const handleHomeClick = () => {
    navigate(-1);
  };

  if (!assessmentId) {
    return <p>Error: {error}</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  if (!settings) {
    return <p>Loading...</p>;
  }

  const isExamButtonDisabled = attempt > settings.no_of_attempts;

  return (
    <>
      <div style={{ background: "#263F86", fontFamily: "Manrope-Regular" }}>
        <div className="custom-container">
          <div className="row">
            <div className="col-md-12">
              <h4 className="text-white mt-3 d-flex justify-content-between align-items-center">
                {settings.assessment_name || "Assessment Name Not Available"}
                <Button
                  variant="light"
                  size="sm"
                  onClick={handleHomeClick}
                  style={{ fontSize: "0.9rem" }}
                >
                  Back
                </Button>
              </h4>
              <p className="text-white">Attempt {attempt}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container mt-4 text-center"
        style={{
          background: "#6c757d",
          color: "white",
          borderRadius: "8px",
          padding: "15px 0",
          fontFamily: "Manrope-Regular",
        }}
      >
        <Row>
          <Col md={4}>
            <h6>
              <strong style={{ fontSize: "22px" }}>
                {settings.questions || 0}
              </strong>
              <br /> Questions
            </h6>
          </Col>
          <Col md={4}>
            <h6>
              <strong style={{ fontSize: "22px" }}>
                {settings.questions || 0}
              </strong>
              <br /> Max Score
            </h6>
          </Col>
          <Col md={4}>
            <h6>
              <strong style={{ fontSize: "22px" }}>
                {settings.no_of_attempts || 0}
              </strong>
              <br /> Max attempt(s)
            </h6>
          </Col>
        </Row>
        <hr style={{ borderColor: "#ccc" }} />
        <h6>
          <span style={{ fontSize: "1.2rem" }}>🕒</span>{" "}
          <strong>
            {settings.time || 0} {settings.unit || "hours"} (time limit)
          </strong>
        </h6>
        <p className="mt-">
          Your answers are saved automatically. If you leave before submitting,
          you can return and resume the same attempt.
          <br />
          <br />
          ⚠️ Once the timer reaches zero, your attempt will be submitted
          automatically.
        </p>
      </div>

      {previousAttempt && (
        <div
          className="container mt-4 text-center"
          style={{
            backgroundColor: "#34495e",
            color: "white",
            borderRadius: "8px",
            padding: "20px",
            fontFamily: "Manrope-Regular",
          }}
        >
          <h5>Your Previous Attempt Stats</h5>
          <p className="fw-bold mt-2" style={{ fontSize: "1.2rem" }}>
            Status:{" "}
            <span style={{ color: "#ffc107" }}>{previousAttempt.status}ted</span>
          </p>
          <p>
            Submitted on:{" "}
            {formatDateTime(previousAttempt.created_at)}
          </p>
          <p>Time Taken: {previousAttempt.duration || "N/A"}</p>
          <Button variant="light" size="sm">
            View your previous attempt(s)
          </Button>
        </div>
      )}

<div className="container text-center mt-4 d-flex justify-content-center gap-3">
  {previousAnswers?.status === "unsubmit" ? (
    <Button
      style={{
        fontSize: "1.1rem",
        padding: "10px 20px",
        fontFamily: "Manrope-Regular",
        background: isExamButtonDisabled ? "#B91C1C" : "#263F86",
      }}
      onClick={handlePreviousExamClick}
      disabled={isExamButtonDisabled}
    >
      {isExamButtonDisabled ? "Max Attempts Reached" : "Resume Assessment"}
    </Button>
  ) : (
    <Button
      style={{
        fontSize: "1.1rem",
        padding: "10px 20px",
        fontFamily: "Manrope-Regular",
        background: isExamButtonDisabled ? "#B91C1C" : "#263F86",
      }}
      onClick={handleExamClick}
      disabled={isExamButtonDisabled}
    >
      {isExamButtonDisabled ? "Max Attempts Reached" : "Start Now"}
    </Button>
  )}
</div>


    </>
  );
}

export default AttemptPage;
